<template>
  <custom-dialog
    :title="$t('asm_add_case_dialog.tian_jia_an_li')"
    :visible="visible"
    v-on="$listeners"
    width="1000px"
    class="add-case-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="info-content">
        <div class="item-title">{{$t('asm_add_case_dialog.she_bei_xin_xi')}}</div>
        <div class="btn-content">
          <el-button
            type="primary"
            @click="onSelDevice"
            class="btn-sel-device"
            v-if="model.type !== 'checkbox'"
          >{{$t('asm_add_case_dialog.xuan_ze_she_bei')}}</el-button>
        </div>
        <div
          class="base-info"
          v-if="deviceInfo.deviceId"
        >
          <el-row :gutter="15">
            <el-col :span="8">
              {{$t('asm_add_case_dialog.chan_pin_xing_hao')}}：{{deviceInfo.productCode || '-' }}
            </el-col>
            <el-col :span="8">
              {{$t('asm_add_case_dialog.ji_shen_hao')}}：{{deviceInfo.bodyNum || '-' }}
            </el-col>
            <el-col :span="8">
              {{$t('asm_add_case_dialog.ke_hu_ming_cheng')}}：{{deviceInfo.customerName || '-' }}
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="8">
              {{$t('asm_add_case_dialog.xiang_mu_ming_cheng')}}：{{deviceInfo.locationName || '-' }}
            </el-col>
            <el-col :span="8">
              {{$t('asm_add_case_dialog.shou_hou_gong_si')}}：{{deviceInfo.afterServiceName || '-' }}
            </el-col>
            <el-col :span="8">
              {{$t('asm_add_case_dialog.di_zhi')}}：{{deviceInfo.projectAddress||deviceInfo.gpsAddress || '-' }}
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="info-content">
        <div class="item-title">{{$t('asm_add_case_dialog.fu_wu_xin_xi')}}</div>
        <el-form
          label-position="top"
          :model="form"
          :rules="rules"
          ref="form"
        >
          <el-row :gutter="15" v-show="serviceClassVisible || createModeVisible">
            <el-col :span="12" v-show="serviceClassVisible">
              <el-form-item
                :label="$t('asm_add_case_dialog.fu_wu_lei_bie')"
                prop="serviceClass"
              >
                <custom-select
                  code="asm_case_order_service_class"
                  v-model="form.serviceClass"
                  @change="serviceClassChange"
                  @getList="getServiceClassDic"
                  :disabled="true"
                ></custom-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" v-show="createModeVisible">
              <el-form-item
                :label="$t('asm_add_case_dialog.chuang_jian_fang_shi')"
                prop="createMode"
              >
                <custom-select
                  :disabled="true"
                  code="asm_case_order_create_mode"
                  v-model="form.createMode"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-if="form.serviceClass === serviceClassDicMap.maintain"
            :gutter="15"
          >
            <el-col>
              <el-form-item
                :label="$t('asm_add_case_dialog.wei_xiu_yuan_yin')"
                prop="itemIds"
                :class="{
                  'is-required' : !form.itemIds.length && !form.additionalItem
                }"
              >
                <custom-select
                  multiple
                  url="BasicItemList"
                  :params="{serviceClass:form.serviceClass}"
                  :props="{label: 'itemName', value: 'itemId'}"
                  v-model="form.itemIds"
                  :disabled="!form.serviceClass"
                  ref="itemIds"
                  @change="itemIdsChange"
                  :dataFilter="itemIdsFilter"
                  :filterOptions="deviceInfo.productCode"
                ></custom-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item
                :label="$t('asm_add_case_dialog.miao_shu')"
                prop="additionalItem"
                :class="{
                  'is-required' : !form.itemIds.length && !form.additionalItem
                }"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  :placeholder="$t('asm_add_case_dialog.bcgzxqhtxqtyy')"
                  v-model="form.additionalItem"
                  @input="additionalItemChange"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_add_case_dialog.lian_xi_ren')"
                prop="contactName"
              >
                <el-input v-model="form.contactName"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('asm_add_case_dialog.lian_xi_ren_dian_hua')"
                prop="mobilePhone"
              >
                <el-input v-model="form.mobilePhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="15">
            <el-col>
              <el-form-item :label="$t('asm_add_case_dialog.scgztp')">
                <t-upload
                  v-model="form.attachList"
                  :attachType="1"
                  :limit="3"
                  bizType="asm.service.request"
                  ref="caseOrderImage"
                  :autoUpload="false"
                ></t-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <select-device-dialog
      v-if="selectDeviceVisible"
      @close="selectDeviceVisible=false"
      :model="selectDeviceModel"
      @confirm="selDeviceConfirm"
    ></select-device-dialog>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="closeDialog">{{$t('Common.com_cancel')}}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
      >{{$t('Common.com_submit')}}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';
import tUpload from '@/components/upload';
import apis from '@/utils/apis';
import selectDeviceDialog from './select_device_dialog';

export default {
  name: '',
  mixins: [dialogMixins],
  components: { tUpload, selectDeviceDialog },
  props: {
    // 服务类别 visible
    serviceClassVisible: {
      type: Boolean,
      default: true,
    },
    // 创建方式 visible
    createModeVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // fix: validate bug,首次进入dialog，会自动提示异常
      firstCheckItemIds: true,
      form: {
        // 服务类型 asm_case_order_service_class
        serviceClass: '',
        // 创建方式  asm_case_order_create_mode
        createMode: '3',
        // 维修原因  BasicItemList   serviceClass: 10
        itemIds: '',
        // 描述
        additionalItem: '',
        // 联系人
        contactName: '',
        // 联系人电话
        mobilePhone: '',
        // 上传附件
        attachList: [],
      },
      selectDeviceVisible: false,
      selectDeviceModel: {},
      deviceInfo: {},
      serviceClassDicMap: {},
    };
  },
  computed: {
    rules() {
      return {
        serviceClass: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        createMode: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        itemIds: {
          validator: this.checkItemIds
        },
        additionalItem: {
          validator: this.checkAdditionalItem
        },
        contactName: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            max: 20,
            message: this.$t('Common.com_rules_length_max', [20]),
          },
        ],
        mobilePhone: [
          {
            type: 'string',
            required: true,
            message: this.$t('Common.com_required')
          },
          {
            min: 7,
            max: 15,
            message: this.$t('Common.com_rules_length_range', [7,15])
          },
        ],
      };
    }, },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    itemIdsFilter(list, productCode) {
      let ret = [...list];
      if (productCode) {
        ret = ret.filter(item => item.productCode === productCode);
      }

      return ret;
    },
    itemIdsChange() {
      const itemIds = this.form.itemIds;
      if (itemIds.length) {
        this.$refs.form.clearValidate('additionalItem');
      }
    },
    additionalItemChange() {
      const additionalItem = this.form.additionalItem;
      if (additionalItem.length) {
        this.$refs.form.clearValidate('itemIds');
      }
    },
    getServiceClassDic(data) {
      const map = {};
      data.forEach((item) => {
        map[item.code] = item.value;
      });
      this.serviceClassDicMap = map;
      this.form.serviceClass = this.serviceClassDicMap.maintain;
    },
    serviceClassChange() {
      this.form.itemIds = [];
    },
    checkItemIds(rule, value, cb) {
      const { itemIds, additionalItem } = this.form;
      if (!itemIds.length && !additionalItem.length) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },
    checkAdditionalItem(rule, value, cb) {
      const { itemIds, additionalItem } = this.form;
      if (additionalItem && additionalItem.length > 200) {
        cb(new Error(this.$t('asm_add_case_dialog.zui_duo200ge_zi_fu')));
        return;
      }
      if (!itemIds.length && !additionalItem.length) {
        cb(new Error(this.$t('Common.com_required')));
        return;
      }
      cb();
    },
    // 选择设备
    onSelDevice() {
      this.selectDeviceModel = {
        title: this.$t('asm_add_case_dialog.xuan_ze_she_bei'),
      };
      this.selectDeviceVisible = true;
    },
    selDeviceConfirm(list) {
      this.deviceInfo = list[0];
    },
    closeDialog() {
      this.visible = false;
    },
    async onConfirm() {
      if (!this.deviceInfo.deviceId) {
        this.$message({
          message: this.$t('asm_add_case_dialog.qing_xuan_ze_she_bei'),
          type: 'error',
        });
        return;
      }
      await this.$refs.caseOrderImage.submit();
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.$postJSON(apis.caseOrderSave, this.getReqData(), true);
          this.$message({
            message: this.$t('Common.com_add_success'),
            type: 'success',
          });
          this.closeDialog();
          this.$emit('success');
        }
      });
    },
    getReqData() {
      const ret = {
        ...this.form,
      };
      const { itemIds } = this.form;
      if (this.deviceInfo.bodyNum) {
        ret.bodyNum = this.deviceInfo.bodyNum;
      }
      if (!itemIds) {
        ret.itemIds = [];
      }
      return ret;
    },
    initDialog() {
      // 不用选择设备  设备是通过data带进来
      if (this.model.type === 'checkbox') {
        this.deviceInfo = this.model.data;
        // 创建方式
        this.form.createMode = this.model.createMode;
      } else {
        // 默认选择初始设备（产品的要求）
        this.onSelDevice();
      }
    },

  },
  created() { },
  mounted() {
    this.initDialog();
  },
};
</script>

<style lang="scss" scoped>
.add-case-dialog {
  .info-content {
    .btn-content {
      overflow: hidden;
      .btn-sel-device {
        float: left;
      }
    }
    // .tips {
    //   float: left;
    //   line-height: 32px;
    //   margin-left: 10px;
    // }
    &:nth-child(1) {
      .base-info {
        background: #f9f9f9;
        border-radius: 10px;
        padding: 10px;
        font-size: 12px;
        line-height: 26px;
        margin-top: 15px;
      }
    }
    &:nth-child(2) {
      margin-top: 20px;
    }
  }
}
</style>
